var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48682 11.25V7.65906H14.5263C15.3259 7.65906 16.0921 8.3946 16.0921 9.45452C16.0921 10.5145 15.3259 11.25 14.5263 11.25H9.48682Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48682 16.3409V12.75H15.6842C16.4838 12.75 17.25 13.4855 17.25 14.5455C17.25 15.6054 16.4838 16.3409 15.6842 16.3409H9.48682Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.6447 5V6.15909H12.0395V5C12.0395 4.58579 12.3753 4.25 12.7895 4.25C13.2037 4.25 13.5395 4.58579 13.5395 5V6.15909H14.5263C16.2847 6.15909 17.5921 7.70283 17.5921 9.45455C17.5921 10.2209 17.3419 10.9475 16.9131 11.5223C18.0181 12.0407 18.75 13.2349 18.75 14.5455C18.75 16.2972 17.4426 17.8409 15.6842 17.8409H13.5395V19C13.5395 19.4142 13.2037 19.75 12.7895 19.75C12.3753 19.75 12.0395 19.4142 12.0395 19V17.8409H10.6447V19C10.6447 19.4142 10.309 19.75 9.89474 19.75C9.48052 19.75 9.14474 19.4142 9.14474 19V17.8409H7C6.58579 17.8409 6.25 17.5051 6.25 17.0909C6.25 16.6767 6.58579 16.3409 7 16.3409H7.98684V7.65909H7C6.58579 7.65909 6.25 7.3233 6.25 6.90909C6.25 6.49488 6.58579 6.15909 7 6.15909H9.14474V5C9.14474 4.58579 9.48052 4.25 9.89474 4.25C10.309 4.25 10.6447 4.58579 10.6447 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.3ed25641735fcbc6290e232f025c2c40.svg";
export { ForwardRef as ReactComponent };